export default __webpack_public_path__ + "static/media/5.74621f4f.jpeg";